module.exports = __webpack_public_path__ + "img/treatment-plan.a43a81e7.png";